<template>
  <div class="twitter-analytics-public-chart">
    <el-tabs v-model="activeTab">
      <el-tab-pane class="graph-container" label="キャンペーン" name="campaigns">
        <TwitterAnalyticsPublicCampaign></TwitterAnalyticsPublicCampaign>
      </el-tab-pane>
      <el-tab-pane class="graph-container" label="応募者のフォロワー数" name="applicantFollowers">
        <TwitterAnalyticsPublicChartFollower></TwitterAnalyticsPublicChartFollower>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TwitterAnalyticsPublicCampaign from '@/client/features/twitter_analytics_public/twitter_analytics_public_campaign'
import TwitterAnalyticsPublicChartFollower from '@/client/features/twitter_analytics_public/twitter_analytics_public_chartfollower'

export default defineComponent({
  components: { TwitterAnalyticsPublicCampaign, TwitterAnalyticsPublicChartFollower },
  data() {
    return {
      activeTab: 'campaigns'
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.twitter-analytics-public-chart {
  .graph-container {
    padding: $spacing-unit ($spacing-unit * 3);
    border: 1px solid $border-color;
    border-radius: math.div($spacing-unit, 2);
  }
}
</style>
